import { CloudinaryType, TypeImageWrapper } from '@fm-nx/contentful-types';
import { CldImage } from 'next-cloudinary';
import useDimensions from 'react-cool-dimensions';

export interface ImageResponsiveFullProps {
    image?: TypeImageWrapper<'WITHOUT_UNRESOLVABLE_LINKS'>;
    publicId?: string;
    altText?: string;
}

export function ImageResponsiveFull(props: ImageResponsiveFullProps) {
    const { observe } = useDimensions<HTMLDivElement | null>();
    const { image, publicId, altText } = props;

    // Use proper type casting for the cloudinaryMedia field
    const cloudinaryMedia = image ? (image.fields.cloudinaryMedia as Array<CloudinaryType>) : undefined;
    const cloudinaryPublicId = cloudinaryMedia ? cloudinaryMedia?.[0]?.public_id : publicId;

    if (!cloudinaryPublicId) {
        return null;
    }

    return (
        <section className="image-container-responsive">
            <div className="relative" ref={observe}>
                <CldImage
                    className="image-responsive"
                    fill
                    // Advanced performance optimizations for Next.js 15
                    format="auto" // Automatically use WebP or AVIF based on browser support
                    quality="auto" // Automatically adjust quality based on network and device
                    dpr="auto" // Automatically adjust for device pixel ratio
                    sizes={'100vw'}
                    src={cloudinaryPublicId}
                    alt={altText || (image?.fields.altText as string) || `${image?.fields.title} Hero`}
                    loading="lazy"
                    fetchPriority="auto"
                    placeholder="blur"
                    blurDataURL="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiB2aWV3Qm94PSIwIDAgMTAwIDEwMCI+PHJlY3Qgd2lkdGg9IjEwMCUiIGhlaWdodD0iMTAwJSIgZmlsbD0iI2YzZjRmNiIvPjwvc3ZnPg=="
                />
            </div>
        </section>
    );
}

export default ImageResponsiveFull;
